import { FormDateSelectItemLabel } from "./FormDateSelectItemLabel";

import { FormSelectItem, FormSelectItemProps } from "@/forms-design-system/FormSelectField";

type FormDateSelectItemProps = Omit<FormSelectItemProps, "children"> & {
  startDate: Date | number;
  endDate: Date | number;
  isSoldOut?: boolean;
  isClosed?: boolean;
  wrapOnMobile?: boolean;
  timezone?: string | null;
};

export const FormDateSelectItem = ({
  startDate,
  endDate,
  isSoldOut,
  isClosed,
  disabled,
  wrapOnMobile,
  timezone,
  ...rest
}: FormDateSelectItemProps) => {
  return (
    <FormSelectItem disabled={isSoldOut || isClosed || disabled} {...rest}>
      <FormDateSelectItemLabel
        startDate={startDate}
        endDate={endDate}
        isSoldOut={isSoldOut}
        isClosed={isClosed}
        wrapOnMobile={wrapOnMobile}
        timezone={timezone}
      />
    </FormSelectItem>
  );
};
